import { Box, styled } from '@mui/material';
import { Icon, IconButton } from '@sdb/planning-ui';

import { protocolIconSize } from '../../Protocols.styles';

export const ActivityCell = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  height: '100%',
  width: '100%'
}));

/** The note icon after the activity name; its tooltip holds the rule's remarks */
export const NoteIcon = styled(Icon)(({ theme }) => protocolIconSize(theme));

/** A rule's pencil and trash can, the same size as the card's own pencil */
export const RuleActionButton = styled(IconButton)(({ theme }) => ({
  '& svg': protocolIconSize(theme)
}));

export const TotalCell = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  fontWeight: theme.typography.fontWeightBold
}));

export const EmptyState = styled(Box)(({ theme }) => ({
  padding: theme.spacing(6),
  border: `1px dashed ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  textAlign: 'center',
  color: theme.palette.text.secondary
}));

/** The row's pencil and trash can, in their own column pinned right after the totals */
export const RuleActions = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(0.5),
  height: '100%'
}));

/** "+ Regel toevoegen", below the grid and in the empty state */
export const AddRuleRow = styled('div')(({ theme }) => ({
  display: 'flex',
  padding: theme.spacing(1, 0)
}));
